import { render, staticRenderFns } from "./rp-roles-content.vue?vue&type=template&id=1ecdfceb"
import script from "./rp-roles-content.vue?vue&type=script&lang=js"
export * from "./rp-roles-content.vue?vue&type=script&lang=js"
import style0 from "./rp-roles-content.vue?vue&type=style&index=0&id=1ecdfceb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports